<section id="secao-apoio">
  <div class="container">
    <div class="row pt-5">
      <div class="col-md-12 col-sm-12 titulo">
        <h3>Apoio cultural</h3>
      </div>
      <div class="col-md-12 col-sm-12 texto">
        A Fundação Educere tem o seu foco na inovação, tanto de forma empresarial quanto da forma de projetos culturais, para que jovens e adultos possam adquirir novas habilidades e também novos amores por meio da dança, escultura e canto.
      </div>
    </div>
  </div>
</section>

<section id="secao-cultural" *ngFor="let secao of secoesCulturais">
  <div class="container pt-5">
    <div class="row pb-5">
      <div class="col-md-2 col-sm-12 d-none d-md-block">
        <img [src]="secao.icone" class="icone" />
      </div>
      <div class="col-md-10 col-sm-12 titulo">
        {{ secao.titulo }}
        <div class="texto">
          {{ secao.texto }}
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 borda d-flex align-items-center justify-content-center">
    <div class="row">
      <div class="col-md-4 col-sm-12" *ngFor="let imagem of secao.imagens">
        <img [src]="imagem" class="imagens img-fluid">
      </div>
    </div>
  </div>
</section>


                            <!-- MODO HARD -->
<!-- <section id="secao-cultural">
  <div class="container pt-5">
    <div class="row pb-5">
      <div class="col-md-2 col-sm-12 d-none d-md-block">
        <img src="assets/imagens/apoio-cultural/sapatilha.png" class="icone" />
      </div>
      <div class="col-md-10 col-sm-12 titulo">
        Ballet Educere
        <div class="texto">
          Aulas gratuitas de dança contemporânea para jovens e adultos que sempre quiseram dançar, mas nunca tiveram a oportunidade de aprender.
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 borda d-flex align-items-center justify-content-center">
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <img src="assets/imagens/apoio-cultural/ballet_educere_cortado.jpg" class="imagens img-fluid">
      </div>
      <div class="col-md-4 col-sm-12">
        <img src="assets/imagens/apoio-cultural/Ballet_Educere2_cortado.jpg" class="imagens img-fluid">
      </div>
      <div class="col-md-4 col-sm-12">
        <img src="assets/imagens/apoio-cultural/Ballet_Educere3_cortado.jpg" class="imagens img-fluid">
      </div>
    </div>
  </div>
</section>

<section id="secao-cultural">
  <div class="container pt-5">
    <div class="row pb-5">
      <div class="col-md-2 col-sm-12 d-none d-md-block">
        <img src="assets/imagens/apoio-cultural/escultura_icon.png" class="icone" />
      </div>
      <div class="col-md-10 col-sm-12 titulo">
        Ateliê de Escultura
        <div class="texto">
          O curso é voltado a estudantes de 12 a 16 anos e tem o objetivo de ensinar a arte da escultura, oferecendo aulas gratuitas de desenho artístico e modelagem em argila, com material todo incluso gratuitamente.
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 borda d-flex align-items-center justify-content-center">
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <img src="assets/imagens/apoio-cultural/Escultura_cortado.png" class="imagens img-fluid">
      </div>
      <div class="col-md-4 col-sm-12">
        <img src="assets/imagens/apoio-cultural/Escultura2_cortado.png" class="imagens img-fluid">
      </div>
      <div class="col-md-4 col-sm-12">
        <img src="assets/imagens/apoio-cultural/Escultura3_cortado.png" class="imagens img-fluid">
      </div>
    </div>
  </div>
</section>

<section id="secao-cultural">
  <div class="container pt-5">
    <div class="row pb-5">
      <div class="col-md-2 col-sm-12 d-none d-md-block">
        <img src="assets/imagens/apoio-cultural/orquestra.png" class="icone" />
      </div>
      <div class="col-md-10 col-sm-12 titulo">
        Orquestra e Coral
        <div class="texto">
          Curso voltado aos jovens e adultos com objetivo de ensinar a arte do canto e da música de forma gratuita.
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 borda d-flex align-items-center justify-content-center">
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <img src="assets/imagens/apoio-cultural/CarpeDiem.jpeg" class="imagens img-fluid">
      </div>
      <div class="col-md-4 col-sm-12">
        <img src="assets/imagens/apoio-cultural/CarpeDiem2_cortado.png" class="imagens img-fluid">
      </div>
      <div class="col-md-4 col-sm-12">
        <img src="assets/imagens/apoio-cultural/CarpeDiem3_cortado.png" class="imagens img-fluid">
      </div>
    </div>
  </div>
</section> -->

